import { combineReducers } from 'redux';

import { FooterSettingsReducerState, footerSettingsReducer } from '../footer-settings/store/footer-settings-reducer';
import { HeaderBannerReducerState, headerBannerReducer } from '../header-banner/store/header-banner-reducer';
import { NewsPostReducerState, newsPostReducer } from '../news-post/store/news-post-reducer';
import { SponsorBannerReducerState, sponsorBannerReducer } from '../sponsor-banner/store/sponsor-banner-reducer';
import { StaticSitesReducerState, staticSitesReducer } from '../static-sites/store/static-sites-reducer';
import {
    SupplierSpecialOffersReducerState,
    supplierSpecialOffersReducer,
} from '../supplier-special-offers/store/supplier-special-offers-reducer';

export interface ContentManagementReducerState {
    headerBanner: HeaderBannerReducerState;
    newsPost: NewsPostReducerState;
    staticSites: StaticSitesReducerState;
    supplierSpecialOffers: SupplierSpecialOffersReducerState;
    sponsorBanner: SponsorBannerReducerState;
    footerSettings: FooterSettingsReducerState;
}

export const contentManagementReducer = combineReducers<ContentManagementReducerState>({
    headerBanner: headerBannerReducer,
    newsPost: newsPostReducer,
    staticSites: staticSitesReducer,
    supplierSpecialOffers: supplierSpecialOffersReducer,
    sponsorBanner: sponsorBannerReducer,
    footerSettings: footerSettingsReducer,
});
